// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__oy+RP","visible":"ScrollToTop_visible__NV1Cl"};